import { react, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import LoadingIndicator from '../LoadingIndicator'
import TokenService from '../../services/TokenService';
import FeedbackIcon from '@mui/icons-material/Feedback';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

export default function ConfirmSilenceLateNotification(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [silenceReason, setSilenceReason] = useState('');
    const [formErrors, setFormErrors] = useState([]);
    const handleClose = (didAccept) => {
        if (didAccept) {
            let isValid = true;
            let errors = [];
            if (silenceReason.trim() == '') {
                isValid = false;
                errors['silenceReason'] = 'Required';
            }
            setFormErrors(errors);

            if (isValid) {


                setIsLoading(true);

                let postData = {
                    requestId: props.pickupRequest.RequestID,
                    message: silenceReason
                }

                TokenService.post(postData, 'SilenceNotifications')
                    .then((response) => {
                        response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            props.Close(true, props.pickupRequest);
                        }
                        else {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        }
                    })
                    .catch((response) => {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    });
            }
        }
        else {
            props.Close(false);
        }
        
      
    };
   


  

    return <div>
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Silence this Late Notification?
            </DialogTitle>
            <DialogContent>
                <div style={{ marginTop: '15px' }}>
                    Let us know why you need to silence this notification:
                </div>
                <div style={{marginTop:'15px'} }>
                    <TextField value={silenceReason} onChange={(e) => setSilenceReason(e.target.value)} label='Reason' error={formErrors['silenceReason'] !== undefined} />
                </div>
                {formErrors['silenceReason'] == undefined ? null : 
                    <div style={{color:'var(--sipzee-red)', fontStyle:'italic'} }>
                        {formErrors['silenceReason'] }
                    </div>
                }
                
                <div style={{ marginTop: '15px' }}>
                    <FeedbackIcon style={{ color: 'var(--sipzee-red)' }} /> Late Pickups and No Shows are the most common reason for customer frustration. <QuestionAnswerIcon style={{ color: 'var(--sipzee-green)' }} /> Please make sure you are communicating with the customer.
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose(false)} autoFocus>
                    Cancel
                </Button>
                <Button onClick={() => handleClose(true)} autoFocus>
                    Accept
                </Button>
            </DialogActions>
        </Dialog>
    </div>


}